import React from "react";
import { Modal, View, Text, TouchableOpacity, StyleSheet, ScrollView } from "react-native";
import { Theme } from "../enum/Theme";
import { ageRangeList } from "@enum/AgeRangeList";
import SpaceH from "@comps/SpaceH";

interface Props {
    visible: boolean;
    value: string[]; // array de IDs selecionados
    onSelect: (list: string[]) => void;
    onClose: () => void;
}

export const ModalFiltroAgeRange: React.FC<Props> = ({ visible, value, onSelect, onClose }) => {
    const toggleSelect = (v: string) => {
        let newArr: string[];
        if (value.includes(v)) {
            newArr = value.filter(item => item !== v);
        } else {
            newArr = [...value, v];
        }
        onSelect(newArr);
    };

    return (
        <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
            <View style={styles.backdrop}>
                <View style={styles.modalBox}>
                    <Text style={styles.title}>Filtrar por idade</Text>
                    <ScrollView showsVerticalScrollIndicator={false}>
                        {ageRangeList.map((item) => (
                            <TouchableOpacity
                                key={item.value}
                                style={[styles.item, value.includes(item.value) && styles.selected]}
                                onPress={() => toggleSelect(item.value)}
                            >
                                <Text style={value.includes(item.value) ? styles.selectedText : styles.text}>
                                    {item.label}
                                </Text>
                            </TouchableOpacity>
                        ))}
                        <SpaceH size={100}/>
                    </ScrollView>
                    <TouchableOpacity onPress={onClose} style={styles.closeBtn}>
                        <Text style={styles.closeBtnText}>Fechar</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </Modal>
    );
};

const styles = StyleSheet.create({
    backdrop: {
        flex: 1, backgroundColor: "rgba(0,0,0,0.30)", justifyContent: "center", alignItems: "center"
    },
    modalBox: {
        width: 280, backgroundColor: "#fff", borderRadius: 10, padding: 22, elevation: 8, flex: 1
    },
    title: { fontSize: 18, fontWeight: "bold", marginBottom: 20, textAlign: "center" },
    item: { paddingVertical: 12, borderRadius: 5, marginBottom: 4, alignItems: "center" },
    selected: { backgroundColor: Theme.foreground },
    text: { color: "#222" },
    selectedText: { color: "#fff", fontWeight: "bold" },
    closeBtn: { padding: 10, borderRadius: 10, alignItems: "center", backgroundColor: 'gray' },
    closeBtnText: { color: '#fff', fontWeight: "bold" },
});
